import VerifyOutSalesDebitNote from "../../../../components/@documents/sales_debit_notes/VerifyOutSalesDebitNote";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function SalesDebitNoteVerifyOutPage() {

    return (
        <VerifyOutSalesDebitNote 
            routeType={routeTypes.admin}
        />
    )
}